import api from '@/services/api'

export default {
  fetchMessages(page) {
    return api.get(`WorkPosts/?ordering=-priority&page=${page}`)
              .then(response => response.data)
  },
  fetchMessage(msgId) {
    return api.get(`WorkPosts/${msgId}/`)
              .then(response => response.data)
  },
  postMessage(payload) {
    return api.post(`WorkPosts/`, payload)
              .then(response => response.data)
  },
  deleteMessage(msgId) {
    return api.delete(`WorkPosts/${msgId}`)
              .then(response => response.data)
  }
}